/* RESPONSIBLE TEAM: team-omni */
import Service from '@ember/service';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type Store from '@ember-data/store';
import type Session from 'embercom/services/session';

export default class DiscordIntegrationService extends Service {
  @service declare store: Store;
  @service declare session: Session;

  @tracked hasStaleIntegration = false;
  @tracked existingIntegrationsIds: string[] | null = null;

  async loadIntegration(): Promise<void> {
    if (!this.session.workspace.isFeatureEnabled('discord-channel')) {
      return;
    }

    try {
      let response = await fetch(`/ember/discord/integrations?app_id=${this.session.workspace.id}`);

      if (response.ok) {
        let integrations = await response.json();
        this.existingIntegrationsIds = integrations.map(
          (integration: { id: string }) => integration.id,
        );
        //We will need to add proper stale check here later (or remove this)
        this.hasStaleIntegration = false;
      } else {
        console.error('Error loading Discord integration:', response.statusText);
        this.existingIntegrationsIds = null;
        this.hasStaleIntegration = false;
      }
    } catch (e: unknown) {
      console.error('Error loading Discord integration:', e);
      this.existingIntegrationsIds = null;
      this.hasStaleIntegration = false;
    }
  }
}

declare module '@ember/service' {
  interface Registry {
    'discord-integration-service': DiscordIntegrationService;
  }
}
